import React from 'react';
import { useLang } from '../contexts/LanguageContext';
import PageBanner from '../components/PageBanner';
import Gallery from '../components/Gallery';

const GalleryPage = () => {
  const { t } = useLang();
  return (
    <>
      <PageBanner tag={t.gallery.tag} title={t.gallery.title} subtitle={t.gallery.subtitle} />
      <Gallery hideHeader />
    </>
  );
};

export default GalleryPage;
